import { render, staticRenderFns } from "./ApproveOrder.vue?vue&type=template&id=41527cbf&scoped=true&"
import script from "./ApproveOrder.vue?vue&type=script&lang=js&"
export * from "./ApproveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41527cbf",
  null
  
)

export default component.exports